document.addEventListener("DOMContentLoaded", () => {
  // Function to update the Klarna monthly payment message
  function updateKlarnaPayment() {
    // Select the price element using the specific CSS selector
    const priceElement = document.querySelector(
      ".product-info__price .price__current"
    );

    // If the price element exists, extract and process the price
    if (priceElement) {
      // Extract the price text, remove any non-numeric characters, and convert to a number
      const priceText = priceElement.textContent.replace(/[^\d.]/g, "");
      const priceValue = parseFloat(priceText);

      // Ensure the price is valid before proceeding
      if (!isNaN(priceValue)) {
        // Calculate the monthly payment by dividing by 3
        const monthlyPayment = (priceValue / 3).toFixed(2);

        // Update the monthly payment text
        document.getElementById(
          "klarna-monthly-payment"
        ).textContent = `£${monthlyPayment}`;
      }
    }
  }

  // Initial update on page load
  updateKlarnaPayment();

  // Add event listener for variant selection changes
  const variantSelectors = document.querySelectorAll(".opt-label--btn");
  variantSelectors.forEach((selector) => {
    selector.addEventListener("click", () => {
      // Delay slightly to allow price update before recalculating Klarna payment
      setTimeout(updateKlarnaPayment, 100);
    });
  });
});
